import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Info, AlertCircle, CheckCircle } from 'lucide-react';

export function AlertsSection() {
  return (
    <Card className='mb-8'>
      <CardHeader>
        <CardTitle>Alerts</CardTitle>
        <CardDescription>Notification and alert messages</CardDescription>
      </CardHeader>
      <CardContent className='space-y-4'>
        <Alert>
          <Info className='h-4 w-4' />
          <AlertTitle>Information</AlertTitle>
          <AlertDescription>This is an informational alert message.</AlertDescription>
        </Alert>

        <Alert variant='destructive'>
          <AlertCircle className='h-4 w-4' />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>This is an error alert message.</AlertDescription>
        </Alert>

        <Alert className='border-green-200 bg-green-50 text-green-800'>
          <CheckCircle className='h-4 w-4' />
          <AlertTitle>Success</AlertTitle>
          <AlertDescription>This is a success alert message.</AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  );
}
